"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var ArrowLeft_1 = require("./icons/ArrowLeft");
var ArrowRight_1 = require("./icons/ArrowRight");
var Button_1 = require("./Button");
var Grid_1 = require("./Grid");
var animationDuration = 500;
var btnStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    zIndex: 1,
};
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    carousel: {
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        width: '100%',
    },
    container: {
        display: 'inline-flex',
        flexWrap: 'nowrap',
        transition: 'none',
        width: '100%',
    },
    animated: {
        '$container&': {
            transition: "transform ".concat(animationDuration, "ms ease-out"),
        },
    },
    prevBtn: __assign(__assign({}, btnStyle), { left: theme.go.schemes.spacing.units.M }),
    nextBtn: __assign(__assign({}, btnStyle), { right: theme.go.schemes.spacing.units.M }),
    slide: {
        flex: '0 0 auto',
        left: 0,
    },
    prevSlide: {
        position: 'absolute',
        transform: 'translateX(-100%)',
    },
    nextSlide: {
        position: 'absolute',
        transform: 'translateX(100%)',
    },
    grid: {
        width: "calc(100% + ".concat(theme.go.schemes.spacing.units.L, "px)"),
    },
}); });
function Carousel(_a) {
    var items = _a.items, _b = _a.itemsPerSlide, itemsPerSlide = _b === void 0 ? 1 : _b, SlideComponent = _a.SlideComponent, outerClasses = _a.classes, preserveColumns = _a.preserveColumns;
    var classes = useStyles({ preserveColumns: preserveColumns });
    var _c = __read((0, react_1.useState)([0, Math.min(itemsPerSlide, items.length)]), 2), range = _c[0], setRange = _c[1];
    var _d = __read((0, react_1.useState)(true), 2), isPristine = _d[0], setPristine = _d[1];
    var _e = __read((0, react_1.useState)(0), 2), move = _e[0], setMove = _e[1];
    var containerRef = (0, react_1.useRef)();
    var direction = (0, system_1.useTheme)().direction;
    var k = direction === 'rtl' ? -1 : 1;
    var currentItems = (0, react_1.useMemo)(function () { return items.slice(range[0], range[1]); }, [items, range]);
    var prevItems = (0, react_1.useMemo)(function () { return items.slice(Math.max(0, range[0] - itemsPerSlide), range[0]); }, [
        items,
        itemsPerSlide,
        range,
    ]);
    var nextItems = (0, react_1.useMemo)(function () { return items.slice(range[1], range[1] + itemsPerSlide); }, [
        items,
        itemsPerSlide,
        range,
    ]);
    var visibleItems = (0, react_1.useMemo)(function () { return __spreadArray(__spreadArray(__spreadArray([], __read(prevItems), false), __read(currentItems), false), __read(nextItems), false); }, [
        currentItems,
        nextItems,
        prevItems,
    ]);
    var setNextSlideSafe = (0, react_1.useCallback)(function (dir) {
        if (move) {
            // prevent multiple clicks
            return;
        }
        setMove(dir);
    }, [move]);
    var onNextClick = (0, react_1.useCallback)(function () {
        setNextSlideSafe(-nextItems.length);
        setPristine(false);
    }, [nextItems.length, setNextSlideSafe]);
    var onPrevClick = (0, react_1.useCallback)(function () {
        setNextSlideSafe(prevItems.length);
    }, [prevItems.length, setNextSlideSafe]);
    var commitSlide = (0, react_1.useCallback)(function (e) {
        if (e.target !== containerRef.current || !move)
            return;
        setRange([range[0] - move, range[1] - move]);
        setMove(0);
    }, [move, range]);
    var transformStyle = (0, react_1.useMemo)(function () { return ({
        transform: move
            ? "translateX(".concat(((move - prevItems.length) / itemsPerSlide) * 100 * k, "%)")
            : "translateX(".concat((-prevItems.length / itemsPerSlide) * 100 * k, "%)"),
    }); }, [move, itemsPerSlide, prevItems.length, k]);
    var containerProps = {
        ref: containerRef,
        className: (0, utils_1.cn)(classes.container, outerClasses === null || outerClasses === void 0 ? void 0 : outerClasses.container, move ? classes.animated : undefined, preserveColumns ? classes.grid : undefined),
        onTransitionEnd: commitSlide,
        style: transformStyle,
        children: visibleItems.map(function (item, i) { return (react_1.default.createElement(SlideComponent, { key: i, item: item, index: range[0] - prevItems.length + i })); }),
    };
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(classes.carousel, outerClasses === null || outerClasses === void 0 ? void 0 : outerClasses.carousel) },
        isPristine || !prevItems.length ? null : (react_1.default.createElement("div", { className: classes.prevBtn, onClick: onPrevClick },
            react_1.default.createElement(Button_1.Button, { startIcon: direction === 'rtl' ? react_1.default.createElement(ArrowRight_1.ArrowRightIcon, null) : react_1.default.createElement(ArrowLeft_1.ArrowLeftIcon, null), variant: system_1.ButtonVariants.Float }))),
        preserveColumns ? (react_1.default.createElement(Grid_1.Grid, __assign({}, containerProps, { flex: true, flexWrap: "nowrap", spacing: "L" }))) : (react_1.default.createElement("div", __assign({}, containerProps))),
        !!nextItems.length && (react_1.default.createElement("div", { className: classes.nextBtn, onClick: onNextClick },
            react_1.default.createElement(Button_1.Button, { startIcon: direction === 'rtl' ? react_1.default.createElement(ArrowLeft_1.ArrowLeftIcon, null) : react_1.default.createElement(ArrowRight_1.ArrowRightIcon, null), variant: system_1.ButtonVariants.Float })))));
}
exports.Carousel = Carousel;
